<script lang="ts" setup>
import { useSidebarGroup } from '../../composables/useSidebarGroup';
import { computed } from 'vue';
import SidePanelSection from '../SidePanel/SidePanelSection.vue';
import { useLocale } from '../../composables/useLocale';

defineProps<{
  loading?: boolean;
}>();

const { t } = useLocale();
const { group, isGroupLoading } = useSidebarGroup();

// GroupOutput exposes createdAt/updatedAt (epoch ms) and expiresAt (epoch ms | null).
const formatDate = (ms?: number | null) => (ms ? new Date(ms).toLocaleDateString().replace(/(\/)/g, '-') : null);

const createdAtDate = computed(() => formatDate(group.value?.createdAt) ?? t('lcp.unknown'));
const updatedAtDate = computed(() => formatDate(group.value?.updatedAt) ?? t('lcp.unknown'));
const expiresAtDate = computed(() => formatDate(group.value?.expiresAt));
</script>

<template>
  <SidePanelSection :title="t('lcp.group_info')" :loading="loading || isGroupLoading">
    <v-skeleton-loader type="paragraph" v-if="isGroupLoading"></v-skeleton-loader>
    <div class="d-flex flex-column" v-if="!isGroupLoading">
      <v-row :dense="true">
        <v-col>
          <v-tooltip location="top" :text="t('lcp.expiry_date_info')">
            <template #activator="{ props: tooltipProps }">
              <v-chip v-bind="tooltipProps" prepend-icon="mdi-calendar-clock" append-icon="mdi-information-outline">
                {{ t('lcp.expiry_date') }}:&nbsp;
                <span v-if="expiresAtDate" class="text-error font-weight-medium">{{ expiresAtDate }}</span>
                <span v-else>{{ t('lcp.not_set') }}</span>
              </v-chip>
            </template>
          </v-tooltip>
        </v-col>
      </v-row>

      <v-row :dense="true">
        <v-col>
          <v-chip prepend-icon="mdi-reload"> {{ t('lcp.last_update') }}: {{ updatedAtDate }} </v-chip>
        </v-col>
      </v-row>

      <v-row :dense="true">
        <v-col>
          <v-chip prepend-icon="mdi-calendar-month"> {{ t('lcp.created') }}: {{ createdAtDate }} </v-chip>
        </v-col>
      </v-row>
    </div>
  </SidePanelSection>
</template>
